import React from 'react'
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import Maybe from './Maybe';
import { useLocation } from 'react-router-dom';


const TableEmptyData = ({title, subtitle, useSubtitle, actionButtonText, actionButtonClicked}) => {
    
    const location = useLocation()
    
    const queryParams = new URLSearchParams(window.location.search);
    const hasSearchKeyword = queryParams.has("search") && queryParams.get("search").trim() !== '';
    const hasQueryParam = location?.search?.includes("?");
    
    return (
        <div className="py-20 mx-auto text-center text-base">
            <div className="flex justify-center">
                <img src={IconEmptyBox} alt="Empty" className="h-36" />
            </div>
            <div className="text-[#101828] font-medium">
                {(hasSearchKeyword || hasQueryParam) ? "No results found" : title || "No Data Available Yet"}
            </div>
            
            <Maybe condition={useSubtitle && (!hasSearchKeyword || !hasQueryParam)}>
                <div className="mt-1 text-[#4A5564]">
                    {subtitle || "Once you start transacting, it would appear here"}
                </div>
            </Maybe>
            
            <Maybe condition={actionButtonText?.length > 0 && (hasQueryParam === false && hasSearchKeyword === false)}>
                <button onClick={actionButtonClicked} className="mt-1 text-ep-primary-500 underline">
                    {actionButtonText}
                </button>
            </Maybe>
        </div>
    )
}

export default TableEmptyData